import React from 'react';
import PropTypes from 'prop-types';
import OverviewTable from '../../../components/Table/OverviewTable';
import localization from '../../../i18n/localization';

const columnDefinition = [
  { id: 'actions', label: localization.de.shop.categoryTable.ACTIONS },
  { id: 'id', label: localization.de.shop.categoryTable.ID },
  { id: 'title', label: localization.de.shop.categoryTable.TITLE },
  { id: 'enabled', label: localization.de.shop.categoryTable.ENABLED },
  { id: 'type', label: localization.de.shop.categoryTable.TYPE },
  { id: 'position', label: localization.de.shop.categoryTable.POSITION },
];

export default function CategoryTable({
  categories,
  onClick,
  onPositionChange,
}) {
  return (
    <OverviewTable
      rowsPerPage={10}
      columnDefinition={columnDefinition}
      data={categories}
      onCellClick={category => onClick(category.id)}
      onPositionChange={(category, direction) =>
        onPositionChange(category, direction)
      }
    />
  );
}

CategoryTable.propTypes = {
  categories: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  onPositionChange: PropTypes.func.isRequired,
};
CategoryTable.defaultProps = {
  data: [],
};



// WEBPACK FOOTER //
// ./src/views/shop/components/CategoryTable.jsx